module.exports = __webpack_public_path__ + "static/media/dpdlocal-spinner.9165d40d.gif";